import { render, staticRenderFns } from "./CardSpecialty.vue?vue&type=template&id=6035909d&"
import script from "./CardSpecialty.vue?vue&type=script&lang=js&"
export * from "./CardSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./CardSpecialty.vue?vue&type=style&index=0&id=6035909d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports